<template>
    <v-card class="px-4">
        <v-card-title class="mb-2">
            <span class="primary--text">Assign Case</span>
            <v-spacer></v-spacer>
            <v-icon @click="closeAssignCaseDoctorList">
                mdi-close
            </v-icon>
        </v-card-title>
        <v-card-subtitle class="black--text">
            <div>Patient Name: <span class="font-weight-bold">{{ patientName || 'N/A' }}</span></div>
            <div>Case Title: {{ selectedCase.health_concern || 'N/A' }}</div>
            <div>Case No: {{ selectedCase.case_number }}</div>
            <div>Schedule: {{ selectedCase.preferred_datetime | convertToScheduleDateTime }}</div>
        </v-card-subtitle>
        <v-card-text>
            <DoctorComponent :canAssignToDoctor="true"></DoctorComponent>
        </v-card-text>
    </v-card>
</template>

<script>
import DASHBOARD_STORE from "../../store/dashboard.module";
import moment from "moment";

export default {
    components: {
        DoctorComponent: () => import("../../doctor/DoctorComponent")
    },
    filters: {
        convertToScheduleDateTime(value) {
            if (value) {
                let date = moment(value);

                if (date.isValid()) {
                    return date.format("MMM DD, YYYY LT");
                }

                return value;
            }

            return null;
        }
    },
    computed: {
        selectedCase: function() {
            return DASHBOARD_STORE.getters.selectedCase;
        },
        patientName() {
            let patient = this.selectedCase?.patient?.patient || null;

            if(patient) {
                if (patient.full_name) {
                    return patient.full_name;
                } else {
                    return `${patient.first_name} ${patient.middle_name} ${patient.last_name}`;
                }
            }

            return patient;
        }
    },
    methods: {
        closeAssignCaseDoctorList() {
            this.componentKey++;
            DASHBOARD_STORE.commit("showAssignCaseToDoctorList", false);
        },
    }
}
</script>